import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { appointmentIndex } from '../../features/appointment/AppointmentSlice';
import Loading from '../../Loading';
import Heading from './Header';
import { Calendar } from "react-multi-date-picker";
import DatePicker,{DateObject} from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import * as moment from 'jalali-moment';

function Appointments () {

    const dispatch = useDispatch()
    const token = localStorage.getItem('token')
    const date = new DateObject({ calendar: persian, locale: persian_fa })
    const { appointments, loading } = useSelector(state => state.appointment)

    useEffect(() => {
        dispatch(appointmentIndex(token))
    },[])

    return (
        <>
        { loading ? ( <Loading /> ) : ''}
        <Heading title={'مدیریت درخواست های غیرحضوری'} />
        <table className="table table-hover" style={{direction: 'rtl'}}>
            <thead className="table-light">
                <tr>
                <th scope="col" className='text-center'>#</th>
                <th scope="col">نام</th>
                <th scope="col">نام خانوادگی</th>
                <th scope="col" className='text-center'>شماره موبایل</th>
                <th scope="col" className='text-center'>نوع شماره</th>
                <th scope="col" className='text-center'>کد ملی</th>
                <th scope="col" className='text-center'>وضعیت</th>
                <th scope="col" className='text-center'>تاریخ ایجاد</th>
                </tr>
            </thead>
            <tbody className="table-group-divider">
                {
                    appointments.map((appointment,key) => (
                        <tr>
                            <th className='text-center'>{++key}</th>
                            <td>{appointment.name}</td>
                            <td>{appointment.family}</td>
                            <td className='text-center'>{appointment.mobile}</td>
                            <td className='text-center'>{appointment.nationalCode}</td>
                            <td className='text-center'>
                                {(appointment.status == 1) ? '-' : '-'}
                            </td>
                            <td className='text-center'>
                                {moment(appointment.created_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}
                            </td>
                        </tr>
                    ))
                }
            </tbody>
        </table>
        <div className='col-12 text-center'>
        <button className='btn btn-outline-dark px-0'>نمایش بیشتر</button>

        </div>
        </>
    )
}

export default Appointments;